import { jsx as _jsx } from "react/jsx-runtime";
import { useMediaQueryMatchesOnDesktop } from '@yonderland/andes-react';
import { useState } from 'react';
import { Button, ButtonVariant, ButtonSize, IconName, IconSize, IconAnimation, useIsClient, } from '@as/cotopaxi';
import { showMobileHeader } from '../../../util/HtmlElementUtil';
const initialState = { animate: false };
const AddToWishlistButton = ({ isProductInWishList, onToggle, wishListProduct, isStickyBar, buttonProps, }) => {
    const [animate, setAnimate] = useState(initialState.animate);
    const isDesktop = useMediaQueryMatchesOnDesktop();
    const isClient = useIsClient();
    const toggleWishListProduct = () => {
        onToggle(wishListProduct);
        setAnimate(!isProductInWishList);
        !isDesktop && showMobileHeader();
    };
    return (_jsx(Button, Object.assign({ noBubble: true, dataQA: "add_to_wishlist", onClick: toggleWishListProduct, variant: ButtonVariant.OUTLINED_ALT, size: !isStickyBar ? ButtonSize.LARGE : undefined, icon: {
            name: !isClient ? IconName.HEART_EMPTY : isProductInWishList ? IconName.HEART : IconName.HEART_EMPTY,
            size: !isStickyBar ? IconSize.MAJOR : IconSize.MEDIUM,
            animation: animate ? IconAnimation.HEART_PULSE : undefined,
        } }, buttonProps)));
};
export default AddToWishlistButton;
